// extracted by css-extract-rspack-plugin
export default {"anchor":"Be4p6ng_MOAh_aAL","label":"XLRq59S4Rc0UZv_j"};